import React, { cloneElement } from 'react';

import { Button } from 'components/button/Button';
import { Row } from 'components/row/Row';

import s from './Cta.scss';
import { useIntl } from 'react-intl';

interface IProps {
  heading?: string;
  children?: React.ReactNode;
  linkText?: string;
  to: string;
  isColumnLayout?: boolean;
  image?: React.ReactElement;
}

export const Cta = ({ heading, children, linkText, to, isColumnLayout, image }: IProps) => {
  if (!to) {
    return null;
  }

  const intl = useIntl();
  const buttonOnly = !image && !children;

  return (
    <Row>
      <aside className={s('cta', { offset: !isColumnLayout, buttonOnly, hasImage: image })}>
        <div className={s.cta__inner}>
          {buttonOnly ? (
            <Button to={to}>
              {heading ??
                linkText ??
                intl.formatMessage({ id: 'cta.label', defaultMessage: 'Meira' })}
            </Button>
          ) : (
            <Row>
              {image && (
                <div className={s.cta__imageCol}>
                  <div className={s.cta__imageWrap}>
                    {cloneElement(image, {
                      className: s.cta__image,
                    })}
                  </div>
                </div>
              )}
              <div className={s.cta__contentCol}>
                {heading && <h2 className={s.cta__heading}>{heading}</h2>}
                {children}
                <div className={s.cta__buttonWrap}>
                  <Button className={s.cta__button} to={to}>
                    {linkText ??
                      heading ??
                      intl.formatMessage({ id: 'cta.label', defaultMessage: 'Meira' })}
                  </Button>
                </div>
              </div>
            </Row>
          )}
        </div>
      </aside>
    </Row>
  );
};
